// Native Shopify forms remain fully usable without JavaScript.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const section = select.closest('[data-product-section]');
  const option = select.selectedOptions[0];
  const price = section.querySelector('[data-product-price]');
  const button = section.querySelector('[data-add-button]');
  const quantity = section.querySelector('[name="quantity"]');

  const fragment = document.createElement('span');
  fragment.className = 'price';
  if (option.dataset.compare) {
    const previous = document.createElement('del');
    previous.textContent = option.dataset.compare;
    fragment.append(previous);
  }
  const current = document.createElement('strong');
  current.textContent = option.dataset.price;
  fragment.append(current);
  if (option.dataset.unit) {
    const unit = document.createElement('small');
    unit.textContent = option.dataset.unit;
    fragment.append(unit);
  }
  price.replaceChildren(fragment);
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? 'Esaurita' : 'Aggiungi al carrello +';
  quantity.min = option.dataset.min || '1';
  quantity.step = option.dataset.step || '1';
  quantity.value = quantity.min;
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');

  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
  const media = document.getElementById(option.dataset.media);
  if (media) media.scrollIntoView({ behavior: 'auto', block: 'nearest' });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.mobile-menu[open], .nav-dropdown[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});

// Custom elements also initialize when Shopify reloads a section in the editor.
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('.product-lightbox');
    this.links = [...this.querySelectorAll('[data-product-image]')];
    if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

    for (const link of this.links) link.setAttribute('aria-haspopup', 'dialog');
    this.addEventListener('click', (event) => {
      const link = event.target.closest('[data-product-image]');
      if (link) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = link;
        this.showImage(this.links.indexOf(link));
        this.dialog.showModal();
      } else if (event.target.closest('[data-lightbox-close]')) {
        this.dialog.close();
      } else if (event.target.closest('[data-lightbox-previous]')) {
        this.showImage(this.index - 1);
      } else if (event.target.closest('[data-lightbox-next]')) {
        this.showImage(this.index + 1);
      } else if (event.target === this.dialog || event.target.matches('[data-lightbox-stage]')) {
        this.dialog.close();
      }
    }, options);
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.showImage(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    }, options);
    this.dialog.addEventListener('close', () => {
      this.opener?.focus({ preventScroll: true });
      this.querySelector('[data-lightbox-stage]').replaceChildren();
    }, options);
  }

  showImage(index) {
    this.index = (index + this.links.length) % this.links.length;
    const link = this.links[this.index];
    const preview = link.querySelector('img');
    const image = document.createElement('img');
    image.alt = preview.alt;
    image.src = link.href;
    this.querySelector('[data-lightbox-stage]').replaceChildren(image);
    this.querySelector('[data-lightbox-count]').textContent = `${this.index + 1} / ${this.links.length}`;
    for (const button of this.querySelectorAll('[data-lightbox-previous], [data-lightbox-next]')) {
      button.hidden = this.links.length < 2;
    }
  }

  disconnectedCallback() {
    if (this.dialog?.open) this.dialog.close();
    this.controller?.abort();
  }
}

if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
